import { createRouter, createWebHistory } from 'vue-router'
import ProductsCenter from '@/views/ProductsCenter.vue'
import WomuMain from '@/views/WomuMain.vue'
import Ai_platform from '@/views/Ai_platform.vue'
import Pro_leader from '@/views/Pro_leader.vue'
import Manage_platform from '@/views/Manage_platform.vue'
import System_platform from '@/views/System_platform.vue'
import NewsMess from '@/views/NewsMess.vue'
import WorkCase from '@/views/WorkCase.vue'
import AboutUs from '@/views/AboutUs.vue'
import NewsDetail from '@/components/NewsDetail.vue'
import SulMthods from '@/views/SulMthods.vue'
import SmartHeating from '@/views/SmartHeating.vue'
import WomuBackend from '@/components/WomuBackend.vue'
import DetailPage from '@/components/DetailPage.vue'
import caseDetail from '@/views/caseDetail.vue'

import WomuMainEN from '@/views/WomuMainEN.vue'
import Ai_platformEN from '@/views/Ai_platformEN.vue'
import Pro_leaderEN from '@/views/Pro_leaderEN.vue'
import Manage_platformEN from '@/views/Manage_platformEN.vue'
import System_platformEN from '@/views/System_platformEN.vue'
import NewDetail from '@/views/NewDetail.vue'
import NewsMessEN from '@/views/NewsMessEN.vue'
import WorkCaseEN from '@/views/WorkCaseEN.vue'
import AboutUsEN from '@/views/AboutUsEN.vue'
import NewsDetailEN from '@/components/NewsDetailEN.vue'
import SulMthodsEN from '@/views/SulMthodsEN.vue'
import SmartHeatingEN from '@/views/SmartHeatingEN.vue'
import DetailPageEN from '@/components/DetailPageEN.vue'
import caseDetailEN from '@/views/caseDetailEN.vue'

import ProductDetail from '@/views/ProductDetail.vue'
import ProductDetailEN from '@/views/ProductDetailEN.vue'
import ProductHardCenter from '@/views/ProductHardCenter.vue'
import ProductHardCenterEN from '@/views/ProductHardCenterEN.vue'
import ProductHardDetail from '@/views/ProductHardDetail.vue'
import ProductHardDetailEN from '@/views/ProductHardDetailEN.vue'
import SolutionDetail from '@/views/SolutionDetail.vue'
import SolutionDetailEN from '@/views/SolutionDetailEN.vue'
import DeviceTypeDetail from '@/views/DeviceTypeDetail.vue'
import DeviceTypeDetailEN from '@/views/DeviceTypeDetailEN.vue'

const routes = [
  { path: '/', component: WomuMain, },
  { path: '/producer', component: Pro_leader },
  { path: '/ai', component: Ai_platform },
  // { path: '/data', component: Data_platform },
  { path: '/manage', component: Manage_platform },
  { path: '/system', component: System_platform },
  { path: '/newDetail', component: NewDetail },
  { path: '/news', component: NewsMess },
  { path: '/case', component: WorkCase },
  { path: '/about', component: AboutUs },
  { path: '/newsdetail', component: NewsDetail },
  { path: '/methods', component: SulMthods },
  { path: '/smartheating', component: SmartHeating },
  { path: '/backend', component: WomuBackend, },
  { path: '/detail', component: DetailPage },
  { path: '/casedetail', component: caseDetail },
  { path: '/productdetail', component: ProductDetail },
  { path: '/producthard', component: ProductHardCenter },
  { path: '/productharddetail', component: ProductHardDetail },
  { path: '/solutiondetail', component: SolutionDetail },
  { path: '/devicetypedetail', component: DeviceTypeDetail },


  { path: '/en/', component: WomuMainEN },
  { path: '/en/producer', component: Pro_leaderEN },
  { path: '/en/ai', component: Ai_platformEN },
  // { path: '/en/data', component: Data_platformEN },
  { path: '/en/manage', component: Manage_platformEN },
  { path: '/en/system', component: System_platformEN },
  { path: '/en/news', component: NewsMessEN },
  { path: '/en/case', component: WorkCaseEN },
  { path: '/en/about', component: AboutUsEN },
  { path: '/en/newsdetail', component: NewsDetailEN },
  { path: '/en/methods', component: SulMthodsEN },
  { path: '/en/smartheating', component: SmartHeatingEN },
  // { path: '/en/backend', component: WomuBackendEN },
  { path: '/en/detail', component: DetailPageEN },
  { path: '/en/casedetail', component: caseDetailEN },
  { path: '/en/productdetail', component: ProductDetailEN },
  { path: '/en/Producthard', component: ProductHardCenterEN },
  { path: '/en/Productharddetail', component: ProductHardDetailEN },
  { path: '/en/solutiondetail', component: SolutionDetailEN },
  { path: '/en/devicetypedetail', component: DeviceTypeDetailEN },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 };
  }
})

export default router
